import DetailsInPopup from "./component";
import { asVariation } from "../../../helper/variations";

DetailsInPopup.Primary = asVariation(DetailsInPopup, "primary", {
  typeStyle: "primary",
});

export { DetailsInPopup };
